/**
 * Build a Zazzle "Linkover" create URL for any product in our catalog.
 *
 * Different Zazzle templates expose their caption text layer under different
 * parameter names — `Name`, `Text`, `Caption`, `Words`, `Message`, etc. To get
 * a consistent result across the whole catalog we send the same value under
 * every common alias; Zazzle silently ignores parameter names a template
 * doesn't define. Empty captions therefore reliably blank the layer (no
 * default placeholder leaks through) on every product.
 */
const CAPTION_FIELDS = [
    't_name_txt',
    't_text_txt',
    't_caption_txt',
    't_words_txt',
    't_message_txt',
    't_quote_txt',
    't_title_txt',
    't_label_txt',
    't_word_txt',
];

const DEFAULT_TC = 'geoshapedmug';

/**
 * Build the Zazzle create URL.
 *
 * `tc` (tracking code) is the Zazzle Associate attribution slot. When a
 * promo code applies, callers pass the lowercased code so the sale is
 * attributed to that influencer in Zazzle's Associate dashboard. When
 * absent we fall back to the historical site-wide tag.
 */
export function getZazzleLink(productId, imageUrl, label, tc) {
    const imageEncoded = encodeURIComponent(imageUrl);
    // Zazzle treats an empty `t_*_txt=` value as "fall back to the template's
    // default placeholder" — that's why an empty caption used to leak through
    // as "Name" on some products. Sending a single space character overrides
    // the placeholder with whitespace, blanking the layer reliably.
    const value = label && label.length > 0 ? label : ' ';
    const labelEncoded = encodeURIComponent(value);
    const captionParams = CAPTION_FIELDS.map((f) => `${f}=${labelEncoded}`).join('&');
    const tcValue = encodeURIComponent(tc || DEFAULT_TC);

    return (
        `https://www.zazzle.com/api/create/at-238144343501339335` +
        `?rf=238144343501339335&ax=Linkover&pd=${productId}` +
        `&ed=false&tc=${tcValue}&ic=` +
        `&t_image_iid=${imageEncoded}` +
        `&${captionParams}`
    );
}

// Back-compat helpers — keep so external callers / older tests don't break.
export function getZazzleMugLink(imageUrl, name) {
    return getZazzleLink('168985417233000053', imageUrl, name);
}

export function getZazzleTShirtLink(imageUrl, name) {
    return getZazzleLink('256170833782451781', imageUrl, name);
}
